import * as React from 'react';
import Experiments, { ExperimentsBag } from '@wix/wix-experiments';
import { ExperimentsProvider as WixExperimentsProvider } from '@wix/wix-experiments-react';
import { InteractionName } from '../../../types/InteractionName';
import { WidgetFedopsLogger } from '../Fedops/FedopsProvider';

export interface IExperimentsWrapperProps {
  experiments: Experiments;
  fedopsLogger: WidgetFedopsLogger;
}

export interface IExperimentsWrapperState {
  experiments: ExperimentsBag | null;
}

// TODO: move experiments to redux from local state (entity - return in hook for call experiments.conduct())
export class ExperimentsProvider extends React.Component<IExperimentsWrapperProps, IExperimentsWrapperState> {
  constructor(props: IExperimentsWrapperProps) {
    super(props);
    this.state = {
      experiments: null,
    };
    this.props.experiments.ready().then(() => {
      this.setState({
        experiments: this.props.experiments.all(),
      });
      this.props.fedopsLogger.interactionEnded(InteractionName.LoadExperiments);
    });
  }

  public render() {
    const { experiments } = this.state;
    if (!experiments) {
      return null;
    }
    return <WixExperimentsProvider options={{ experiments }}>{this.props.children}</WixExperimentsProvider>;
  }
}
